// Imports
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '',
      component: () => import('@/layouts/home/Index.vue'),
      children: [
        {
          path: '/',
          name: 'Inicio',
          component: () => import('@/views/home/Index.vue'),
        },
        {
          path: 'nosotros',
          name: 'Nosotros',
          component: () => import('@/views/nosotros/Index.vue'),
          meta: { src: require('@/assets/about.jpg') },
        },
        {
          path: 'contact-us',
          name: 'Contacto',
          component: () => import('@/views/contact-us/Index.vue'),
          meta: { src: require('@/assets/contact.jpg') },
        },
        {
          path: 'pro',
          name: 'Pro',
          component: () => import('@/views/pro/Index.vue'),
          meta: { src: require('@/assets/pro.jpg') },
        },
        {
          path: '80Mesh',
          name: '80Mesh',
          component: () => import('@/views/Productos/80Mesh/Index.vue'),
          meta: { src: require('@/assets/Water-Jet.jpg') },
        },
        {
          path: '2040Mesh',
          name: '2040Mesh',
          component: () => import('@/views/Productos/2040Mesh/Index.vue'),
          meta: { src: require('@/assets/pro.jpg') },
        },
        {
          path: 'Hidrogel',
          name: 'Hidrogel',
          component: () => import('@/views/Productos/hidrogel/Index.vue'),
          meta: { src: require('@/assets/pro.jpg') },
        },
        {
          path: '*',
          name: 'FourOhFour',
          component: () => import('@/views/404/Index.vue'),
        },
      ],
    },

  ],
})

export default router
